// NPM Imports
import React from "react";

// Internal Imports
import emptyDocumentPlaceholder from "../../assets/empty-doc-placeholder.gif";
import emptyCoverpageHeaderFooterPlaceholder from "../../assets/blank-coverpage-headerfooter-default.png";

const EmptyDocumentPlaceholder = props => {
  const { itemType, hidePlaceholder } = props;
  switch (itemType) {
    case "doc-component":
      return (
        <div
          className={`documentview-emptydocplaceholder-wrapper emptycontainer-component-items ${
            hidePlaceholder ? "hide-placeholder" : ""
          }`}>
          <div className="documentview-emptydocplaceholder-title">
            Welcome to Revv Document Builder
          </div>
          <div className="documentview-emptydocplaceholder-subtitle ">
            you can drag and drop components from the right pane
            <span role="img" aria-label="Finger">
              👉🏾
            </span>{" "}
          </div>
          <div>
            <img
              src={emptyDocumentPlaceholder}
              alt="Revv"
              className="documentview-emptydocplaceholder-image"
            />
          </div>
        </div>
      );
    case "CoverPage":
      return (
        <div
          className={`documentview-emptydocplaceholder-wrapper emptycontainer-component-items ${
            hidePlaceholder ? "hide-placeholder" : ""
          }`}>
          <div className="documentview-emptydocplaceholder-title">
            Customize this cover page
          </div>
          <div className="documentview-emptydocplaceholder-subtitle ">
            you can drag and drop text, table and image components to build
            coverpage
            <span role="img" aria-label="Finger">
              👉🏾
            </span>{" "}
          </div>
          <div>
            <img
              src={emptyCoverpageHeaderFooterPlaceholder}
              alt="Revv"
              className="documentview-emptydocplaceholder-image"
            />
          </div>
        </div>
      );
    case "header":
      return (
        // <div className="documentview-emptydocplaceholder-wrapper">
        //   <div className="documentview-emptydocplaceholder-title">
        //     Customize this Header
        //   </div>
        //   <div className="documentview-emptydocplaceholder-subtitle ">
        //     you can drag and drop text, table and image component to build
        //     header
        //     <span role="img" aria-label="Finger">
        //       👉🏾
        //     </span>{" "}
        //   </div>
        // </div>
        <div />
      );
    case "footer":
      return (
        // <div className="documentview-emptydocplaceholder-wrapper">
        //   <div className="documentview-emptydocplaceholder-title">
        //     Customize this Footer
        //   </div>
        //   <div className="documentview-emptydocplaceholder-subtitle ">
        //     you can drag and drop text, table and image component to build
        //     footer
        //     <span role="img" aria-label="Finger">
        //       👉🏾
        //     </span>{" "}
        //   </div>
        // </div>
        <div />
      );
    default:
      return (
        <div
          className={`documentview-emptydocplaceholder-wrapper emptycontainer-component-items ${
            hidePlaceholder ? "hide-placeholder" : ""
          }`}>
          <div className="documentview-emptydocplaceholder-title">
            Welcome to Revv Document Builder
          </div>
          <div className="documentview-emptydocplaceholder-subtitle ">
            you can drag and drop components from the right pane
            <span role="img" aria-label="Finger">
              👉🏾
            </span>{" "}
          </div>
          <div>
            <img
              src={emptyDocumentPlaceholder}
              alt="Revv"
              className="documentview-emptydocplaceholder-image"
            />
          </div>
        </div>
      );
  }
};

export default EmptyDocumentPlaceholder;



// WEBPACK FOOTER //
// ./src/components/DocumentItems/EmptyDocumentPlaceholder.js